<template>
  <main id='Home' v-if='kirby.page.template'>
    <section v-for="section in introsections"  :key="section.id">
      <ImageRow v-if='section.type=="gallery"' :filenames='section.content.images' :page='kirby.page' />
      <big class='intro' v-if='section.type=="text"' v-html='section.content.text' />
      <section class='artists' v-if='section.type=="artists"'>
        <h6>Artists</h6>
        <nav>
          <router-link :to='"/"+page.uri'
                       v-for='(page, index) in getPagesFromPaths(section.content.list)'
                       :key='index'>
            <h1 v-html='page.strings.title' />
          </router-link>
        </nav>
      </section>
    </section>

    <MainFooter />

  </main>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), et
  computed: {
    introsections: function() {
      return this.kirby.page.strings.intro ? JSON.parse(this.kirby.page.strings.intro) : '';
    }
  }
}
</script>


<style scoped>

  big.intro {
    width: 100%;
    font-family: Face;
    font-size: var(--large);
    font-weight: 100;
    line-height: 1em;
    text-indent: var(--textindent);
    letter-spacing: -0.035em;
    margin-bottom: 5rem;
  }
  section.artists {
    margin-bottom: 5rem;
  }
  nav {
    font-size: var(--large);
    font-weight: 100;
    line-height: 1em;
    text-indent: var(--textindent);
  }
  nav a * {
    color: var(--gray);
    will-change: color;
    transition: color 0.3s ease-in-out;
  }
  a:hover h1, a.active h1 {
    color: var(--darkgray);
  }
  a.router-link-exact-active h1 {
    color: var(--darkgray);
  }
  a {
    text-indent: 0;
    display: inline-block;
    font-size: var(--large);
    line-height: 1em;
    white-space: nowrap;
  }
  a.router-link-exact-active h1 {
    color: black;
  }
  a+a {

  }
  a:not(:last-child)::after {
    font-family: Face;
    font-size: inherit;
    content: ', ';
    margin-right: 0.1em;
    line-height: inherit;
  }
  h1 {
    font-size: inherit;
    display: inline-block;
    line-height: inherit;
  }
</style>
